interface CategoryNavProps {
  categories: Array<{ name: string; slug: string }>;
  selectedCategory: string;
  onSelectCategory: (slug: string) => void;
}

export function CategoryNav({ categories, selectedCategory, onSelectCategory }: CategoryNavProps) {
  return (
    <section className="bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8 md:py-10">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
              分类浏览
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              按类型发现你喜欢的韩漫
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              type="button"
              onClick={() => onSelectCategory(cat.slug)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                selectedCategory === cat.slug
                  ? 'bg-primary-500 text-background-50 shadow-sm'
                  : 'bg-background-50 text-foreground-600 hover:text-primary-500 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}